import React, { useContext } from 'react'
import Spinner  from "./Spinner";
import { PostPurchaseContext, PostPurchaseDispatchContext } from '../context/PostPurchaseContext';
import { getSerialNumberData } from "../utilities";

function BackButton({ beforeDismount = null, handler=null, text="Back", isLoading }) {
    const state = useContext(PostPurchaseContext);
    const dispatch = useContext(PostPurchaseDispatchContext);

    const handleBack = handler || async function(){
        const errors = []

        if (beforeDismount) {
            await beforeDismount()
        }
        dispatch({ type: 'setActiveStep', payload: state.activeStep - 1 })

    }

    return (
        <button
            className="px-[52px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl mx-auto my-8"
            onClick={handleBack}
        >
            {isLoading ? <Spinner /> : `${text}`}
        </button>
    )
}
  
export default BackButton